<template>
    <div class="footer">
        <div class="footer-content">
            <div>主办：{{cityName}}自然资源局&nbsp;&nbsp;&nbsp;｜&nbsp;&nbsp;&nbsp;技术支持：长沙市中智信息技术开发有限公司｜&nbsp;&nbsp;&nbsp;建议使用浏览器:<a style="font-seze:13px" href="https://www.google.cn/intl/zh-CN/chrome/" target="_blank">谷歌浏览器</a> </div>
            <!-- <div class="maintenance">
                <span class="icon">
                    <i class="iconfont icon-phone"></i>
                </span>
                <span class="phone">0731-23220268</span>
            </div> -->
        </div>
    </div>
</template>
<script>
export default {
  data() {
    // 这里存放数据
    return {
      cityName: '株洲'
    }
  },
  created() {
    for (let i = 0; i < city.length; i++) {
      if (city[i].check === true) {
        this.cityName = city[i].cityname
      }
    }
  }
}
</script>
<style lang='scss' scoped>

a:focus, a:hover, a:active, a:visited, a:link {
    text-decoration: none;
    color: #ccc;
}
    .footer{
        width: 100%;
        height: 35px;
        background: #161f2e;
        .footer-content{
            width: 1200px;
            display: flex;
            justify-content: space-between;
            margin: 0 auto;
            font-size: 13px;
            color: #cccccc;
           line-height: 35px;
           padding: 0px 0px;
            .maintenance{
                width: 300px;
                height: 28px;
             /*    background: #2b3950; */
                line-height: normal;
                padding: 5px 10px 12px 23px;
                .icon{
                    width: 24px;
                    height: 24px;
                    background: rgba(255,255,255,0.10);
                    border-radius: 50%;
                    text-align: center;
                    line-height: 24px;
                    display: inline-block;
                    vertical-align: middle;
                    margin-right: 5px;
                    i.iconfont{
                        font-size: 12px;
                    }
                }
                .phone{
                    line-height: 24px;
                    vertical-align: middle;
                    font-size: 16px;
                    font-weight: bold;
                    color: #cccccc;
                }
                .people{
                    vertical-align: middle;
                    font-size: 14px;
                    font-weight: normal;
                    color: #cccccc;
                    margin-right: 10px;
                }
            }
        }
    }
</style>
